import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { certError, pdfBlob } from "@/lib/certs";

export const CertViewDialog = ({ cert, onClose }) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let u = null;
    setUrl(null);
    if (cert) {
      pdfBlob(cert.id).then((b) => { u = URL.createObjectURL(b); setUrl(u); })
        .catch(async (e) => { toast.error(await certError(e)); onClose(); });
    }
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [cert, onClose]);

  return (
    <Dialog open={!!cert} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-5xl bg-card p-4" data-testid="cert-view-dialog">
        <DialogHeader><DialogTitle className="font-head">{cert?.certificate_number} · {cert?.partner_name}</DialogTitle></DialogHeader>
        <div className="aspect-[1.414/1] w-full overflow-hidden rounded-lg border border-border bg-white">
          {url ? <iframe title="certificate" src={`${url}#toolbar=0&view=Fit`} className="h-full w-full" data-testid="cert-view-frame" />
            : <div className="flex h-full items-center justify-center text-sm text-slate-500">Loading certificate…</div>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
